import { includes } from 'lodash';

import EnvironmentSettings from '../../config/settings';
import EmployerRepHttpService from '../api/EmployerRepHttpService';
import { EMPLOYER_REP_STATUSES } from '../constants/EmployerRep';
import Logger from './logger';

export default class EmployerRepService {
    static getSignUpLink = ({ employerRepId, invitationId, newMode = false }) => {
        let host = EnvironmentSettings.TFTAppUrl;
        const invitationPart = invitationId ? `/${invitationId}` : '';
        if (newMode) {
            host = window.location.origin;
            return `${host}/public/employerRep/${employerRepId}/sign-up/details/true${invitationPart}`;
        }
        return `${host}/#/employerRep/${employerRepId}/sign-up/details/true${invitationPart}`;
    };

    static checkIfAllowedToSendFeedbackRequestToEmployerRep = async (employerRepId) => {
        try {
            const employerRep = await EmployerRepHttpService.getEmployerRep(employerRepId);
            const isEmployerRepRemoved = employerRep.removed;
            const allowedStatusesToSendFeedbackRequest = [
                EMPLOYER_REP_STATUSES.ACTIVE,
                EMPLOYER_REP_STATUSES.PENDING,
                EMPLOYER_REP_STATUSES.INVITED,
            ];
            const isEmployerRepStatusSuitable = includes(allowedStatusesToSendFeedbackRequest, employerRep.status.current);
            const isAllowedToSendFeedbackRequest = !isEmployerRepRemoved && isEmployerRepStatusSuitable;
            return isAllowedToSendFeedbackRequest;
        } catch (error) {
            Logger.error(error.message);
            return false;
        }
    };
}
